import { regIsTer } from "@/libs/api";
import { quickRegister, getNewDataApi, getNewGiftApi } from "@/libs/api";
import { setTimeout } from "core-js";

export default {
  name: "join",
  data() {
    return {
      areaIf: false,
      timeif: false,
      yantext: "获取验证码",
      phoneNum: "",
      validNum: "",
      loadhide: false,
      maskhide: false,
      quickReg: "",
      recommendUsrOnlyid: "",
      isSuccess: false,
      baseData: {},
      bgStyle: {},
      couponList: {},
      maker: "",
      couponShow: false,
      clickResist: false,
    };
  },
  mounted() {
    console.log("uleUrl123456", this.$uleUrl());
    this.recommendUsrOnlyid = this.$route.query.recommendUsrOnlyid;
    this.shareId = this.$route.query.shareId;
    console.log(this.shareId); // 分享id
    document.cookie = `ul_sch=ylxdsq;domain=.${this.$uleUrl()};path=/;expires=3600`;
    this.getData();
  },
  methods: {
    areaCheck() {
      this.areaIf = !this.areaIf;
    },
    //  获取验证码
    verIfication() {
      if (!this.timeif) {
        if (this.phoneNum == "") {
          return this.$toast("手机号不能为空哦^_~");
        } else if (!this.isMobile(this.phoneNum)) {
          return this.$toast("一定要填写正确的手机号哦^_~");
        }
        let params = {
          mobile: this.phoneNum,
          clientType: "app_ylxdsq",
        };
        this.loadhide = true;
        regIsTer(params, "jsoncallback").then((res) => {
          this.loadhide = false;
          if (res.returnCode == "0000") {
            this.timeif = true;
            this.$toast("短信验证码发送成功");
            this.countdown(60);
          } else {
            this.$toast(res.returnMessage);
          }
        });
      }
    },
    // 注册
    regIster() {
      if (this.phoneNum == "") {
        return this.$toast("手机号不能为空哦^_~");
      } else if (!this.isMobile(this.phoneNum)) {
        return this.$toast("一定要填写正确的手机号哦^_~");
      }
      if (this.validNum == "") {
        return this.$toast("验证码不能为空哦^_~");
      } else if (this.validNum.length < 6 || this.validNum.length > 6) {
        return this.$toast("验证码是6位数字哦^_~");
      }
      // this.loadhide = true;
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      let params = {
        mobile: this.phoneNum,
        validateCode: this.validNum,
        recommendUsrOnlyid: this.recommendUsrOnlyid,
        recommendChannel: "app_ylxdsq",
        shareId: this.shareId,
        isLogin: 1,
      };
      quickRegister(params, "jsoncallback")
        .then((res) => {
          if (res.returnCode == "0000") {
            this.bgStyle = {
              background: `url(${this.baseData.couponBg}) no-repeat`,
              backgroundSize: "100%",
            };
            setTimeout(() => {
              this.isSuccess = true;
              this.getNewGift();
            }, 2000);
          } else {
            this.$toast(res.returnMessage);
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    // 注册成功获取优惠券信息
    getNewGift() {
      const params = { marker: this.maker };
      getNewGiftApi(params).then((res) => {
        console.log("优惠券结果", res);
        this.$toast.clear();
        if (res.code == "0000" && res.data && JSON.stringify(res.data) !== "{}") {
          this.couponList = res.data;
          this.couponShow = false;
        } else {
          this.couponShow = true;
          this.clickResist = false;
        }
      });
    },
    refreshGetCoupon() {
      if (!this.clickResist) {
        this.clickResist = true;
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: "加载中...",
        });
        this.getNewGift();
      }
    },
    // 倒计时
    countdown(t) {
      let m = this;
      if (--t < 1) {
        m.yantext = "重获验证码";
        m.timeif = false;
      } else {
        m.yantext = t + " 秒后重新获取";
        m.countFlag = setTimeout(function() {
          m.countdown(t);
        }, 1000);
      }
    },
    // 校验手机
    vdMobile() {
      let m = this;
      if (m.phoneNum == "") {
        this.$toast("手机号不能为空哦^_~");
      } else if (!m.isMobile(m.phoneNum)) {
        this.$toast("一定要填写正确的手机号哦^_~");
      }
    },
    isMobile(phoneNum) {
      return new RegExp(/^1[3|4|5|6|7|8|9][0-9]{9}$/).test(phoneNum.trim());
    },
    handleToWeb(type) {
      let url = "";
      if (type == "ule") {
        url = `https://m.${this.$uleUrl()}/muser/coupon/list`;
      } else {
        url = "https://a.app.qq.com/o/simple.jsp?pkgname=com.ule.storecommunity";
      }
      setTimeout(() => {
        window.location = url;
      }, 1000);
    },
    doCopy() {
      this.copyText(this.quickReg, this.toDownload, this.toDownload);
    },
    // 获取基础数据
    getData() {
      getNewDataApi().then((res) => {
        console.log(res);
        let arr = [];
        if (res["laxin_register_ylxdsq"]) {
          arr = res["laxin_register_ylxdsq"][0].customAttribute;
          console.log("arr", arr);
          if (arr.length > 0) {
            this.baseData = JSON.parse(arr);
            this.maker = this.baseData.maker;
            this.bgStyle = {
              background: `url(${this.baseData.registerBg}) no-repeat`,
              backgroundSize: "contain",
              backgroundPosition: "left top",
            };
          }
        }
      });
    },
  },
};
